import DataType from "common/enums/DataType";
import SearchAttributeType from "common/enums/search/SearchAttributeType";
import dateConvert from "common/helper/dateConvert";
import typeCast from "common/helper/typeCast";
/**
 * This contains some helper functions that are useful to configure dropdowns and comboboxs in prompt list.
 */
var me = {

    /**
     * Add text fields to all options.
     * @param promptModel Prompt
     */
    addTextField: function(promptModel) {
        var data = promptModel.data;
        var convert = this.converter(promptModel);
        if (data) {
            data.forEach(function(item) {
                item.text = convert(item.value);
            });
        }
    },

    /**
     * Returns a function that can be used to format values from the server for the given prompt model.
     * Return will be HTML.
     * @param promptModel Prompt configuration
     * @param valueField Field to look for on value
     */
    valueFormatter: function(promptModel, valueField) {
        var convert = this.converter(promptModel);
        return function(item) {
            return "<span>" + $("<span>").text(convert(item[valueField])).html() + "</span>";
        }
    },

    /**
     * Return a function that can format values for a given prompt.
     * @param promptModel
     * @returns {*}
     */
    converter: function(promptModel) {
        if (promptModel.dataType == DataType.DATE) {
            return this.dateFormat;
        } else if (promptModel.dataType == DataType.DECIMAL && promptModel.isCurrency) {
            return this.currencyFormat;
        } else if (promptModel.dataType == DataType.DECIMAL) {
            return this.decimalFormat;
        } else if (promptModel.dataType == DataType.INTEGER) {
            return this.integerFormat;
        } else if (promptModel.attributeType == SearchAttributeType.DOCUMENT_TYPE) {
            return this.docTypeFormat;
        } else {
            return this.stringFormat;
        }
    },

    /**
     * Return a function can parse values for a given prompt.
     * @param promptModel
     * @returns {Function}
     */
    converterBack: function(promptModel) {
        if (promptModel.dataType && promptModel.dataType == DataType.DATE) {
            return this.dateParse;
        } else if (promptModel.dataType && promptModel.dataType == DataType.DECIMAL && promptModel.isCurrency) {
            return this.currencyParse;
        } else if (promptModel.dataType == DataType.DECIMAL) {
            return this.decimalParse;
        } else if (promptModel.dataType == DataType.INTEGER) {
            return this.integerParse;
        } else {
            return this.stringParse;
        }
    },

    /**
     * Format the date.
     * @param value
     */
    dateFormat: function(value) {
        var v = dateConvert.toDate(value);
        if (v !== null) {
            return kendo.toString(v, "d");
        } else {
            return "";
        }
    },

    /**
     * Parse a date.
     * @param v
     * @returns {*}
     */
    dateParse: function(v) {
        var d = kendo.parseDate(v, "d");
        if (d !== null) {
            return dateConvert.toLong(d);
        } else {
            return v;
        }
    },

    /**
     * Format currency value.
     * @param value
     */
    currencyFormat: function(value) {
        return kendo.toString(kendo.parseFloat(value), "c");
    },

    /**
     * Parse a currency value.
     * @param c
     */
    currencyParse: function(c) {
        return kendo.parseFloat(c);
    },

    /**
     * Format a decimal value.
     * @param val Value
     * @returns {*}
     */
    decimalFormat: function(val) {
        return kendo.toString(me.decimalParse(val), "########################.#################");

    },

    /**
     * Parse a decimal value.
     * @param val
     * @returns {*}
     */
    decimalParse: function(val) {
        val = typeCast.toNumber(val);
        if (isNaN(val)) {
            return "";
        } else {
            return val;
        }
    },

    /**
     * Format an integer value.
     */
    integerFormat: function(val) {
        return kendo.toString(me.integerParse(val), "n0");
    },

    /**
     * Parse an integer value.
     * @param val
     */
    integerParse: function(val) {
        val = typeCast.toNumber(val);
        if (isNaN(val)) {
            return "";
        } else {
            return Math.floor(val);
        }
    },

    /**
     * Format doc type.
     * @param value
     */
    docTypeFormat: function(value) {
        var regex = /^(.+?)~~(.+)$/;
        var results = regex.exec(value);
        if (results) {
            return results[2] + " (" + results[1] + ")";
        } else {
            return value;
        }
    },

    /**
     * String format.
     * @param value Value
     * @returns {*}
     */
    stringFormat: function(value) {
        return value;
    },

    /**
     * Parse a string value.
     * @param value
     * @returns {*}
     */
    stringParse: function(value) {
        return value;
    }

};
export default me;
